import { IS_LOADING, SET_ERROR, SET_SUCCESS, SET_DATA_LIST, SET_TOTAL } from "./types";
export default {
    [IS_LOADING](state, isLoading) {
        Object.assign(state, { isLoading });
    },
    [SET_ERROR](state, error) {
        Object.assign(state, { error });
    },
    [SET_SUCCESS](state, success) {
        Object.assign(state, { success });
    },
    [SET_DATA_LIST](state, dataList) {
        Object.assign(state, { dataList });
    },
    [SET_TOTAL](state, total) {
        Object.assign(state, { total });
    },
};
